import React from 'react';
import { Button } from '@mui/material';

export default function ButtonNav({ props, action, disabled = false }) {

	return (
		<Button
			size="large"
			className={'custom_button' + (props.tracking !== null ? ' ' + props.tracking : '')}
			sx={{ width: '90%', fontWeight: 'bold', p: 1.5 }}
			href={props.url}
			onClick={action}
			disabled={disabled}>
			{props.text}
		</Button>
	);
}